import { Flex, Text, Badge, Spinner, Button } from "@radix-ui/themes";
import { CheckCircledIcon } from "@radix-ui/react-icons";
import { UpdateStatus } from "@/api/quackchat/configuration/useConfigManager";

interface LayoutConfigurationHeaderProps {
    title: string;
    status: UpdateStatus;
    isButtonVisible?: boolean;
    onClick?: () => void;
    ctaText?: string;
    isButtonDisabled?: boolean;
    isSecondaryButtonVisible?: boolean;
    onSecondaryClick?: () => void;
    secondaryButtonText?: string;
    isSecondaryButtonDisabled?: boolean;
}

export function LayoutConfigurationHeader({
    title,
    status = "idle",
    isButtonVisible = false,
    onClick,
    ctaText,
    isButtonDisabled = false,
    isSecondaryButtonVisible = false,
    onSecondaryClick,
    secondaryButtonText,
    isSecondaryButtonDisabled = false,
}: LayoutConfigurationHeaderProps) {
    return (
        <Flex justify={"between"} align={"center"} gap={"12px"}>
            <Text size={"3"} weight={"medium"}>
                {title}
            </Text>

            {status === "idle" && (isButtonVisible || isSecondaryButtonVisible) && (
                <Flex align={"center"} gap={"2"}>
                    {isSecondaryButtonVisible && (
                        <Button
                            variant={"ghost"}
                            color="gray"
                            onClick={onSecondaryClick}
                            disabled={isSecondaryButtonDisabled}
                        >
                            {secondaryButtonText ?? "Discard"}
                        </Button>
                    )}
                    {isButtonVisible && (
                        <Button
                            variant={"ghost"}
                            color="gray"
                            onClick={onClick}
                            disabled={isButtonDisabled}
                        >
                            {ctaText ?? "Save"}
                        </Button>
                    )}
                </Flex>
            )}

            {status === "saving" && (
                <Flex align={"center"} gap={"1"}>
                    <Spinner size={"1"} />
                    <Text size={"1"} color={"gray"}>
                        Saving ...
                    </Text>
                </Flex>
            )}

            {status === "saved" && (
                <Badge color={"green"} size={"1"}>
                    <CheckCircledIcon />
                    Saved
                </Badge>
            )}
        </Flex>
    );
}
